import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__base_ui_components_react_tooltip_62648034__ from "@base-ui-components/react/tooltip";
import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__ from "../../variants/tv.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__ from "../CdnIcon/index.js";
const tooltipStyles = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__.tv)({
    slots: {
        baseSlot: 'text-body3 rounded-xl px-3 py-2 transition-all',
        iconSlot: 'mr-1',
        arrowSlot: 'w-(--tooltip-arrow-size) h-(--tooltip-arrow-size) rotate-45 rounded-tl-[3px] [clip-path:polygon(0%_0%,0%_100%,100%_0%)]',
        arrowContainerSlot: 'data-[side=bottom]:top-(--tooltip-arrow-offset-y) data-[side=left]:right-(--tooltip-arrow-offset-x) data-[side=right]:left-(--tooltip-arrow-offset-x) data-[side=top]:bottom-(--tooltip-arrow-offset-y) data-[side=left]:rotate-90 data-[side=right]:-rotate-90 data-[side=top]:rotate-180'
    },
    variants: {
        color: {
            neutral: {},
            success: {},
            error: {}
        },
        emphasis: {
            true: {},
            false: {}
        },
        showArrow: {
            true: {},
            false: {}
        },
        fixedWidth: {
            true: {},
            false: {}
        }
    },
    compoundSlots: [
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            class: 'shadow-lg'
        },
        {
            slots: [
                'baseSlot'
            ],
            fixedWidth: false,
            class: 'w-auto'
        },
        {
            slots: [
                'baseSlot'
            ],
            fixedWidth: true,
            class: 'w-44'
        },
        {
            slots: [
                'arrowSlot'
            ],
            showArrow: false,
            class: 'invisible'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: false,
            class: 'bg-neutral-1'
        },
        {
            slots: [
                'baseSlot'
            ],
            emphasis: false,
            color: 'neutral',
            class: 'text-neutral-11'
        },
        {
            slots: [
                'baseSlot'
            ],
            emphasis: false,
            color: 'success',
            class: 'text-success-11'
        },
        {
            slots: [
                'baseSlot'
            ],
            emphasis: false,
            color: 'error',
            class: 'text-error-11'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: true,
            color: 'neutral',
            class: 'bg-neutral-8 text-neutral-1'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: true,
            color: 'success',
            class: 'bg-success-8 text-neutral-1'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: true,
            color: 'error',
            class: 'bg-error-8 text-neutral-1'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: false,
            color: 'neutral',
            class: 'text-neutral-10'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: false,
            color: 'success',
            class: 'text-success-8'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: false,
            color: 'error',
            class: 'text-error-8'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: true,
            color: 'neutral',
            class: 'text-neutral-4'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: true,
            color: 'success',
            class: 'text-success-7'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: true,
            color: 'error',
            class: 'text-error-7'
        },
        {
            slots: [
                'baseSlot'
            ],
            class: 'motion-safe:data-[starting-style]:animate-fade-in-0-100 transition-duration-extra-short motion-safe:data-[ending-style]:animate-fade-out-100-0 transition-duration-snap'
        }
    ]
});
const ValidTooltipColorValues = Object.keys(tooltipStyles.variants.color);
function Tooltip(props) {
    const { children, triggerNode, className, iconLeft, color = 'neutral', align = 'center', side = 'bottom', showArrow = true, alignOffset = 0, sideOffset = 10, fixedWidth = false, emphasis = false, delay = 600, closeDelay = 0, hoverable = true, open, defaultOpen = false, onOpenChange } = props;
    const { baseSlot, iconSlot, arrowContainerSlot, arrowSlot } = tooltipStyles({
        color,
        emphasis,
        showArrow,
        fixedWidth
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_tooltip_62648034__.Tooltip.Root, {
        delay: delay,
        closeDelay: closeDelay,
        hoverable: hoverable,
        defaultOpen: defaultOpen,
        open: open,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_tooltip_62648034__.Tooltip.Trigger, {
                className: className,
                render: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {}),
                children: triggerNode
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_tooltip_62648034__.Tooltip.Portal, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_tooltip_62648034__.Tooltip.Positioner, {
                    align: align,
                    alignOffset: alignOffset,
                    side: side,
                    sideOffset: sideOffset,
                    arrowPadding: 16,
                    className: "z-1",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_tooltip_62648034__.Tooltip.Popup, {
                        className: baseSlot(),
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__base_ui_components_react_tooltip_62648034__.Tooltip.Arrow, {
                                className: arrowContainerSlot(),
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    className: arrowSlot(),
                                    "data-testid": "tooltip-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                className: "flex flex-row items-start justify-center",
                                children: [
                                    iconLeft && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                                        iconName: iconLeft,
                                        className: iconSlot(),
                                        size: "16"
                                    }),
                                    children
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
export { Tooltip, ValidTooltipColorValues };
